var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',{staticClass:"business-tabs px-4"},[_c('v-tab',{attrs:{"to":"/trips","nuxt":"","ripple":false}},[_vm._v(_vm._s(_vm.$t('trips')))]),_vm._v(" "),_c('v-tab',{attrs:{"to":"/business/travelers","nuxt":"","ripple":false}},[_vm._v(_vm._s(_vm.$t('travelers')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }